import type { IconProps } from 'react-icomoon'
import IcoMoon from 'react-icomoon'
import iconSet from 'assets/selection.json'

const IconMoon = (props: IconProps) => <IcoMoon iconSet={iconSet} {...props} />

export default IconMoon
